import { EFinancingProgram } from '@if/core/types'
import { getApiClient } from '@src/services/api-client'
import { MutationFunction, UseMutateAsyncFunction, useMutation } from '@tanstack/react-query'
import { ElectronicSignature } from '../../types/ElectronicSignature'
import { makeCreate } from '../make-api'

const baseUrl = '/Applications/{financingProgramId}/{creditApplicationId}/ElectronicSignature'

const electronicSignatureApi = {
  resendLink: makeCreate<ElectronicSignature>(`${baseUrl}/ResendLink`),
}

const sendSignatureLink: MutationFunction<
  ElectronicSignature,
  { financingProgramId: EFinancingProgram; creditApplicationId: string }
> = async ({ financingProgramId, creditApplicationId }) => {
  const apiClient = getApiClient()
  const response = await apiClient.post<ElectronicSignature>(
    `/Applications/${financingProgramId}/${creditApplicationId}/ElectronicSignature`,
  )
  return response.data
}

export function useSendSignatureLink(
  financingProgramId: EFinancingProgram,
  creditApplicationId: string,
): [UseMutateAsyncFunction<ElectronicSignature, Error, string, unknown>] {
  const { mutateAsync } = useMutation<ElectronicSignature, Error, string>({
    mutationFn: () => sendSignatureLink({ financingProgramId, creditApplicationId }),
  })

  return [mutateAsync]
}

export default electronicSignatureApi
